<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="商家登录">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
				<div v-if="config && config.store_joinin_open!=0" class="common-btn btn" slot="right" @click="goRegister">入驻</div>
            </mt-header>
        </div>
        <div class="main-content">
            <div class="top-wrapper">
                <div>
                    <flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" v-model="sellername" placeholder="商家账户" /></div></flex-line>
                </div>
                <div>
                    <flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password" placeholder="请输入密码" maxlength="20" /></div></flex-line>
                </div>
            </div>
            <div class="common-btn ds-button-large mt-10 mb-10" @click="signin">登录</div>
        </div>
    </div>
</template>

<script>
import { sellerlogin } from '../../../api/sellerLogin'
import { Indicator, Toast } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import flexLine from '../../flexLine'
export default {
  name: 'login',
  data () {
    return {
      sellername: '',
      password: ''
    }
  },
  components:{flexLine,},
	created: function () {
	  Indicator.close()
	  if (this.$route.query.clear) {
	    this.sellerLogout()
	  }
	  this.fetchConfig({}).then(
	    response => {
	    },
	    error => {
	      Toast(error.message)
	    }
	  )
	},
  computed: {
    ...mapState({
      config: state => state.config.config
    }),
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    ...mapMutations({
      saveAuthInfo: 'sellerLogin',
      saveMemberAuthInfo: 'memberLogin',
      sellerLogout: 'sellerLogout'
    }),
	goRegister () {
	  this.$router.push({ name: 'SellerJoinin1' })
	},
    signin () {
      let sellername = this.sellername
      let password = this.password
      if (sellername.length === 0) {
        Toast('请输入用户名/邮箱/手机号')
        return
      }
      // TODO: 用户名（为手机号或邮箱）校验
      if (password.length === 0) {
        Toast('请输入密码')
        return
      }
      if (password.length < 6) {
        Toast('至少输入6位密码')
        return
      }
      Indicator.open()
      sellerlogin(sellername, password).then(
        response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.goSellerIndex()
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    goSellerIndex () {
      this.$router.push({ name: 'SellerIndex' })
    }
  }
}
</script>

<style scoped lang='scss'>
    .common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
    .container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        .main-content{background: #fff;padding:0 $pageSpace}
    .top-wrapper {
    .input-wrapper {
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 0.5rem;
        background-color: #fff;
        height: 2.2rem;
    img {
        width: 1.2rem;
        height: 1.2rem;
        margin: 0;
        padding: 0;
    }
    input {
        flex: 1;
        font-size:$subFontSize;
    }
    .bottom-input {
        border-bottom-width: 0;
    }
    }
    }
    }
</style>
